// extracted by css-extract-rspack-plugin
module.exports =  {"pendingActions":"ReturnFiled__pendingActions___atpmy"};